import React, { useEffect, useState } from 'react'
import CampaignAdminList from './CampaignAdminList';
import CampaignAdminRead from './CampaignAdminRead';
import CampaignAdminEdit from './CampaignAdminEdit';
import CampaignAdminCreate from './CampaignAdminCreate';
import { useLocation } from 'react-router';
import { FaSearch, FaList, FaPlus, FaInbox, FaCodeBranch } from "react-icons/fa";

function CampaignAdmin() {
  const location = useLocation()
      const [activeAction,setActiveAction] = useState("list-campaigns")
    
      const navItems = [
        { label: 'Create Campaign',  path: '/staff/campaign/create',tab:'create-campaign' },
        { label: 'Campaign',  path: '/staff/campaign/detail',tab:'campaign-detail-view'  },
        { label: 'Edit Campaign',  path: '/staff/campaign/edit',tab:'edit-campaign' },
        { label: 'List Campaign',  path: '/staff/campaigns/',tab:'list-campaigns' },
      ];
    
      
    
       useEffect(()=>{
          // console.log(location)
          if(location?.pathname==="/staff/campaign/create/" && !activeAction !== "create-campaign"){
            setActiveAction("create-campaign")
          }else if(location?.pathname.includes("/staff/campaign/detail") && !activeAction !== "campaign-detail-view"){
            setActiveAction("campaign-detail-view")
          }else if(location?.pathname==="/staff/campaign/edit/" && !activeAction !== "edit-campaign"){
            setActiveAction("edit-campaign")
          }else if(location?.pathname==="/staff/campaigns/" && !activeAction !== "list-campaigns"){
            setActiveAction("list-campaigns")
          }
        },[location])

        useEffect(()=>{
          if(location?.state?.redirect){
            setActiveAction(location?.state?.redirect)
          }
        },[location])
    
        const Createcampaign = (e)=>{
          e.preventDefault()
          setActiveAction("create-campaign")
        }
    
        const Editcampaign = (e)=>{
          e.preventDefault()
          setActiveAction("edit-campaign")
        }
    
        const Listcampaigns = (e)=>{
          e.preventDefault()
          setActiveAction("list-campaigns")
        }
    
  
        const views = {
          "create-campaign":<CampaignAdminCreate/>,
          "edit-campaign":<CampaignAdminEdit/>,
          "campaign-detail-view":<CampaignAdminRead/>,
          "list-campaigns": <CampaignAdminList/>
        }
  
  
    return (
      <div>
          {/* <h3>ProjectAdmin</h3> */}
      <header className="projects-header-admin">
        <h1 className="header-title-admin">Campaigns DashBoard</h1>
  
        <div className="header-controls-admin">
          <div className="search-container">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Type / to search"
              className="search-input"
            />
          </div>
  
          <div className="icon-group">
            
            <button className="icon-button tooltip-container" onClick={Createcampaign}>
              <FaPlus /> <span>New campaign</span> <span class="tooltip-content">New campaign</span>
            </button>
            <button className="icon-button tooltip-container" onClick={Listcampaigns}>
              <FaList /> <span>View campaigns</span> <span class="tooltip-content">List All campaigns</span>
            </button>
            <button className="icon-button">
              <FaCodeBranch />
            </button>
            <button className="icon-button">
              <FaInbox />
            </button>
          </div>
        </div>
      </header>
  
      <div>
          {
            views[activeAction] || views['list-campaigns']
          }
      </div>
      </div>
    )
}

export default CampaignAdmin